import { render, staticRenderFns } from "./langaageComponent.vue?vue&type=template&id=721a7716&scoped=true"
import script from "./langaageComponent.vue?vue&type=script&lang=js"
export * from "./langaageComponent.vue?vue&type=script&lang=js"
import style0 from "./langaageComponent.vue?vue&type=style&index=0&id=721a7716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721a7716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
